export enum MessageTypeEnum {
    none = 0,
    welldone = 1,
    headsup = 2,
    warning = 3,
    ohsnap = 4
}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/enums/message.enum.ts